import React, { useCallback, useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../auth/AuthContext'
import { CorreosConCopia, CumpleanosAutomatizados, LogrosAutomatizados, ReporteDiario, ReporteDiarioEjecutivos, ReporteDiarioGerentes, TablaAvanzado } from '../../Components/Components'




export const Avanzado = ({initState,updateState,dataGerentes,setDataGerentes,loadGerentes,reloadGerentes,dataEjecutivos,setDataEjecutivos,loadEjecutivos,reloadEjecutivos}) => {
  const { usuario } = useContext(AuthContext);
  const [ data,setData ] = useState([]);
  const [idPadre,setIdPadre] = useState("")
  const [flag,setFlag] = useState(false);

  useEffect(()=> {
    let fl = true;
    dataGerentes.map((t,e)=>{
      if(t.rd===0){
        fl = false
      } 
    })
    setFlag(fl)
  },[dataGerentes])

  useEffect(() => {
    getConfiguracionesAvanzadas();
  },[]);


  return (
    <React.Fragment>
      <ReporteDiario 
      initState={initState} 
      updateState={updateState} 
      data={data} 
      setData={setData} 
      setConfiguracionAvanzada={setConfiguracionAvanzada}
      setStatusConfiguracionAvanzada={setStatusConfiguracionAvanzada}
      />

      <CumpleanosAutomatizados 
      initState={initState} 
      updateState={updateState} 
      data={data} 
      setData={setData} 
      setConfiguracionAvanzada={setConfiguracionAvanzada}
      setStatusConfiguracionAvanzada={setStatusConfiguracionAvanzada}
      /> 

      <CorreosConCopia 
      initState={initState} 
      updateState={updateState} 
      data={data} 
      setData={setData} 
      setConfiguracionAvanzada={setConfiguracionAvanzada} 
      setStatusConfiguracionAvanzada={setStatusConfiguracionAvanzada} /> 

      {/* <LogrosAutomatizados initState={initState} updateState={updateState} data={data} />  */}

      <ReporteDiarioGerentes 
      initState={initState} 
      updateState={updateState} 
      data={dataGerentes} 
      setDataGerentes={setDataGerentes}
      load={loadGerentes} 
      reload={reloadGerentes}
      updateStatusReporteDiario={updateStatusReporteDiario}
      updateStatusReporteDiarioForGerentes={updateStatusReporteDiarioForGerentes}
      />
      <ReporteDiarioEjecutivos 
      initState={initState} 
      updateState={updateState}
      data={dataEjecutivos}
      load={loadEjecutivos}
      updateStatusReporteDiario={updateStatusReporteDiario}
      updateStatusReporteDiarioForEjecutivos={updateStatusReporteDiarioForEjecutivos}
      />
      {/* <TablaAvanzado initState={initState} updateState={updateState} data={data} /> */}
    </React.Fragment>
  )


  function getConfiguracionesAvanzadas(){
    const dataSend = {
      id_login: usuario.id_usuario,
    };
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getConfiguracionesAvanzadas`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setData(res.configuraciones_avanzadas);
      });
  }

  function setConfiguracionAvanzada(idPadre,descripcion){
    const dataSend = {
      id_login: usuario.id_usuario,
      id_padre: idPadre,
      descripcion: descripcion
    };
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=setConfiguracionAvanzada`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        console.log(res)
      });
  }


function setStatusConfiguracionAvanzada(idPadre,status){
  const dataSend = {
    id_login: usuario.id_usuario,
    id_padre: idPadre,
    status: status
  };
  fetch(
    `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=setStatusConfiguracionAvanzada`,
    {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(dataSend),
    }
  )
    .then((res) => res.json())
    .then((res) => {
      console.log(res)
    });
}

function updateStatusReporteDiario(idUsuario,status,type){

  const dataSend = {
    id_login: usuario.id_usuario,
    id_usuario: idUsuario,
    status: status
  };

  console.log(dataSend)

  if(type==="gerente"){
    let rd = (status) ? 1 : 0;
    const newArr = [...dataGerentes];
    const newData = newArr.map( element => (
      element.id_usuario === idUsuario ? { ...element, rd } : element
    ))
  
    setDataGerentes(newData);
  }

  if(type==="ejecutivo"){
    let rd = (status) ? 1 : 0;
    const newArr = [...dataEjecutivos];
    const newData = newArr.map( element => (
      element.id_usuario === idUsuario ? { ...element, rd } : element
    ))
  
    setDataEjecutivos(newData);
  }

  
  fetch(
    `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=updateStatusReporteDiario`,
    {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(dataSend),
    }
  )
    .then((res) => res.json())
    .then((res) => {
      console.log(res)
    });
}



function updateStatusReporteDiarioForGerentes(status){
  const dataSend = {
    id_login: usuario.id_usuario,
    status: status
  };

  const newArr = [...dataGerentes];
  const newData = newArr.map( element => { 
    element.rd = (status) ? 1 : 0
    return element;
  })

  setDataGerentes(newData);

  fetch(
    `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=updateStatusReporteDiarioForGerentes`,
    {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(dataSend),
    }
  )
    .then((res) => res.json())
    .then((res) => {
      console.log(res)
    });
}

function updateStatusReporteDiarioForEjecutivos(status){
  const dataSend = {
    id_login: usuario.id_usuario,
    status: status
  };

  const newArr = [...dataEjecutivos];
  const newData = newArr.map( element => { 
    element.rd = (status) ? 1 : 0
    return element;
  })

  setDataEjecutivos(newData);

  console.log(dataSend)
  fetch(
    `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=updateStatusReporteDiarioForEjecutivos`,
    {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(dataSend),
    }
  )
    .then((res) => res.json())
    .then((res) => {
      console.log(res)
    });
}

}
